import { FormlyFieldConfig } from '@ngx-formly/core';

export const sharedMonthDiscount = (): FormlyFieldConfig => ({
  type: 'new-month-select',
  key: 'value',
  props: {
    translate: true,
    checkboxLabel: 'TPA.ForMonths',
    yesText: 'TPA.Yes',
    noText: 'TPA.No',
  },
});
